import { Regions } from 'common/model/account/regions';
import React, { createContext, useContext, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { clientCurrentRegionSelector } from 'redux/selectors';

export type Theme = 'default' | 'green' | 'nric';

interface ThemeContextValue {
  theme: Theme;
  domain: string;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextValue>({
    theme: 'default',
    domain: '',
    setTheme: () => { return; },
});

export const useTheme = () => useContext(ThemeContext);

// FIXME находится в shared, использует бизнес логику -> надо переместить - архитектура не удобная (её нет)
export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const currentRegion = useSelector(clientCurrentRegionSelector);

    const [theme, setTheme] = useState<Theme>('default');
    const [domain, setDomain] = useState<string>('');

    useLayoutEffect(() => {
        let currentTheme: Theme = 'default';

        switch (currentRegion) {
            case Regions.UGRA:
                currentTheme = 'green';
                break;
            case Regions.NRIC:
                currentTheme = 'nric';
                break;
            default:
                currentTheme = 'default';
                break;
        }

        setDomain(window.location.hostname);
        setTheme(currentTheme);
        document.documentElement.setAttribute('data-theme', currentTheme);
    }, [currentRegion]);

    const handleSetTheme = (newTheme: Theme) => {
        setTheme(newTheme);
        document.documentElement.setAttribute('data-theme', newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme: handleSetTheme, domain }}>
            {children}
        </ThemeContext.Provider>
    );
};
